<template>
    <div class="payment-result-wrapper movie-box">

        <div class="movie-gradient payment-title">
            支付页面
        </div>

        <!-- 商品信息 -->
        <div class="detalis_box">

            <div class="quantit">
                <div>
                    <img :src="orderInfo.product_img" alt="" />
                </div>
                <div class="quantiy">
                    <div calss="size" style="padding-top:0.5rem;">{{ cartInfo.product_name }}
                        <div>{{ orderInfo.product_name }}</div>
                    </div>
                    <div class="quan">
                        <div class="tity">
                            ￥{{ orderInfo.price }}
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="orderer acea-row row-between">
            <div></div>
            <div>共{{ c }}件商品 小计：￥ <span style="color: #ee453e;">{{ orderInfo.price }}</span></div>
        </div> -->
        <!-- 支付模块 -->
        <div class="wrapper" v-if="couponsList.length >= 1">
            <div class="item">
                <div class="acea-row row-between">
                    <div>支付方式</div>
                    <span v-if="twoPayTypes && paymentMethod" class="changePayType" @click="changePayType">切换 ></span>
                </div>
                <div>
                    <div class="list acea-row row-middle row-around" v-if="paymentMethod == null">
                        <div class="zfbutton" :class="{ 'onZfbutton': paymentMethod === 'dian' }"
                            @click="choice('dian')">点券支付</div>
                        <div class="zfbutton" :class="{ 'onZfbutton': paymentMethod === 'ci' }" @click="choice('ci')">
                            次券支付</div>
                    </div>
                </div>

                <div class="list" v-show="paymentMethod === 'dian'">

                    <!-- 点券支付 -->
                    <div class="payItem acea-row row-middle" :class="active === 'yue' ? 'on' : ''"
                        @click="payItem('yue')"
                        v-if="Number(orderInfo.price) <= Number(userInfo.coupon_virtually_money)">
                        <div class="name acea-row row-center-wrapper">
                            <div class="iconfont icon-icon-test" :class="active === 'yue' ? 'bounceIn' : ''"></div>
                            点券支付
                        </div>
                        <div class="tip">可用点券：{{ userInfo.coupon_virtually_money || 0 }}</div>
                    </div>

                    <!-- 点券+微信组合支付 -->
                    <div v-else>
                        <div class="payItem acea-row row-middle" :class="active === 'zh' ? 'on' : ''"
                            @click="payItem('zh')">
                            <div class="name acea-row row-center-wrapper">
                                <div class="iconfont icon-icon-test" :class="active === 'zh' ? 'bounceIn' : ''"></div>
                                组合支付
                            </div>
                            <!-- <div class="tip">微信支付点券不足金额</div> -->
                            <div class="tip">点券支付 <span style='color:red;font-size:0.3rem'>{{
                                userInfo.coupon_virtually_money
                                    }}</span>&nbsp;&nbsp;微信支付 <span style='color:red;font-size:0.3rem'>{{
                                        weixin_price(Number(orderInfo.price) -
                                            Number(userInfo.coupon_virtually_money)) }}</span></div>
                        </div>
                        <div class="kydq" :style="{ color: '#999', 'margin-top': '10px' }">
                            可用点券：{{ userInfo.coupon_virtually_money || 0 }}
                        </div>
                    </div>

                </div>
                <div class="list" v-show="paymentMethod === 'ci'">
                    <div class="acea-row row-middle row-between">
                        <span>{{ ciAmountOfMoney ? ciAmountOfMoney + '点次券' : '请选择次券金额' }}</span>
                        <span @click="clickOpenCi(true)">></span>
                    </div>
                    <TicketOrderSelectWindow :twoTypes="true" :arr="ciList" :_isShow="openSelectCi"
                        @checkedOption="checkedOption" @isShow="clickOpenCi" :addTextWords="'点次券'"
                        :markStyle="markStyle"></TicketOrderSelectWindow>
                    <div class="page-margin-top2 acea-row row-middle row-between"
                        v-if="ciAmountOfMoney && (ciAmountOfMoney < orderInfo.price)">
                        <span>微信支付</span>
                        <span class="font-color-red">{{ weixin_price(Number(orderInfo.price) -
                            Number(ciAmountOfMoney)) }}元</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="wrapper" v-else>
            <div class="item">
                <div>支付方式</div>
                <div class="list">

                    <router-link :to="'/user/bindcoupon'" class="binding">
                        <div class="payItem acea-row row-middle">
                            <div class="name acea-row row-center-wrapper">
                                绑定点券
                            </div>
                            <div class="tip">点击绑定点券</div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="orderer acea-row" v-if="cartInfo.ship_type != 'shop'">
            <div>备注：</div>
            <textarea cols="30" rows="3" v-model="beizhu"></textarea>
        </div>

        <div style="height: 1rem;"></div>
        <!-- 立即付款 -->
        <div @click="payFn">
            <MovieBottomButton :text="'确认支付'" :cancel="cancel"></MovieBottomButton>
            <!-- <MovieBottomButton :text="'确认支付'"></MovieBottomButton> -->
        </div>
    </div>
</template>

<script>
import TicketOrderSelectWindow from "@components/TicketOrderSelectWindow.vue";
import MovieBottomButton from "@components/MovieBottomButton.vue";
// import { pay } from "@libs/wechat";
import { getCouponsUser, dgkjPaying } from "@api/cake";
import { payMovieOrderHandle } from "@libs/dgPayment.js";
import { isWeixin } from "@utils";
import { stringToArray, isEmpty, roundFun } from "@utils/movie.js";
import { getUserInfo } from "@api/user";
import { Icon } from "vant";
const NAME = "PaymentResult", _isWeixin = isWeixin();

export default {
    name: NAME,
    components: {
        MovieBottomButton,
        TicketOrderSelectWindow,
        Icon
    },
    data: function () {
        return {
            active: "zh",
            from: _isWeixin ? "weixin" : "weixinh5",
            couponsList: [], //优惠券
            userInfo: {}, //用户信息
            cartInfo: {}, //电影票信息
            orderInfo: {},
            tradeno: {},
            // 轩夸电影使用的uid
            uid: null,
            _expire_time: null,
            minute: 0,
            second: 0,
            cancel: false,
            ciList: [
                // {text:'50',value: 2}, {text:'40',value: 3}
            ], //次券列表
            openSelectCi: false, //是否打开选择次券列表
            paymentMethod: "dian", //支付方式：dian(点券支付) / ci(次券支付) 
            ciAmountOfMoney: 0, //选择次券的金额
            ciId: null, //选择次券的id
            markStyle: {
                background: "rgba(0,0,0,0.7)"
            },
            twoPayTypes: false, // 是否有两种支付方式：点/次 券支付
            letvalue: '',
            goodyu: '',
            beizhu: ''
        }
    },
    created: function () {
        this.decryption();
    },
    mounted: function () {
        var that = this;
        getCouponsUser(0).then(res => { //我的优惠券
            console.log(res);
            that.couponsList = res.data;
            that.ciList = res.data && res.data.filter((item) => {
                return item.types === 2;
            }).map((item) => {
                return {
                    text: item.coupon_price,
                    value: item.id,
                    ...item
                }
            });
            // console.log(res.data,"优惠券");
        });
    },
    computed: {
        minuteS: function () {
            return this.setTime(this.minute);
        },
        secondS: function () {
            return this.setTime(this.second);
        },
        setLoca: function () {
            return stringToArray(this.cartInfo.movie_loca);
        },
    },
    watch: {
        minute: function (newVal) {
            this.setTime(newVal);
        },
        second: function (newVal) {
            this.setTime(newVal);
        }
    },
    methods: {
        changePayType: function () {
            this.paymentMethod = null;
        },
        checkedOption: function (data) {
            this.ciAmountOfMoney = parseFloat(data.text);
            this.ciId = parseFloat(data.value);
        },
        clickOpenCi: function (is) {
            this.openSelectCi = is;
        },
        choice: function (option) {
            this.paymentMethod = option;
        },
        weixin_price: function (n) {
            if (!n) return;
            let val = roundFun(n, 2);
            return val;
        },
        returnText: function (paid) {
            if (paid == 0) {
                return '待支付';
            }
            if (paid == 1) {
                return '已支付';
            }
        },
        timer: function () {

            let _expire_time = new Date(this._expire_time.replace(/-/g, "/")).getTime();//到点的时间
            console.log(_expire_time);

            // let _expire_time = new Date(new Date().setMinutes(new Date().getMinutes() + 15)).getTime()
            let differ = null;
            let DSQ = null;
            DSQ = setInterval(() => {
                let current_time = new Date();//现在的时间
                differ = parseFloat(_expire_time - current_time.getTime()) / 1000;
                this.minute = parseInt(differ / 60);
                this.second = parseInt((parseFloat(differ / 60) - parseInt(differ / 60)) * 60);

                if (differ <= 0 && this.minute <= 0 && this.second <= 0) {
                    clearInterval(DSQ);
                    // console.log(differ, this.minute, this.second);
                    this.minute = 0;
                    this.second = 0;
                    this.cancel = true;
                    this.$dialog.error("支付取消");
                }
            }, 1000)
        },
        setTime: function (data) {
            return data < 10 ? "0" + data : data;
        },
        decryption: function () {
            let _parms = null;
            let query = location.search.substring(1).split(' ');
            for (let i = 0; i < query.length; i++) {
                let pos = query[i].split('order_no=');
                if (pos[0]) {
                    _parms = pos[1] ? pos[1] : '';
                }
            }
            if (isEmpty(_parms)) {
                this.$dialog.error("参数有误");
                // window.history.back(-1);
            }
            //请求用户信息
            getUserInfo(false).then(res => {
                let uid = res.data.uid
                // 解密 获取电影票信息
                dgkjPaying(_parms, uid).then((res) => {
                    console.log(res, "pr-res.data.token");
                    const expires_time = new Date(res.data.token.expires_time.replace(/-/g, "/")).getTime();
                    const datas = {
                        token: res.data.token.token,
                        expires_time: expires_time
                    };
                    this.$store.commit("LOGIN", datas);
                    // 蛋糕订单信息
                    this.orderInfo = res.data.orderInfo
                    this._expire_time = res.data.orderInfo.expire_time;
                    if (res.data.orderInfo.pay_status == 1) {
                        this.$dialog.success('已支付！请前往订单查看');
                        this.$router.replace({ path: '/user' });
                    }
                    // this.timer();
                    this.getUserInfo();


                }).catch((r) => {
                    this.$dialog.error(r.msg);
                    console.log(r, "错误");
                })
            })



        },

        getUserInfo: function () {
            getUserInfo(false).then((res) => {
                console.log(res);
                this.$store.commit("UPDATE_USERINFO", res.data);
                this.userInfo = res.data;
                if (Number(this.orderInfo.price) <= Number(res.data.coupon_virtually_money)) {
                    this.active = 'yue';
                }
                if (res.data.coupon_virtually_money == 0 && (res.data.time_stamps && res.data.time_stamps > 0)) { //有次券无点券
                    this.paymentMethod = "ci";
                } else if (res.data.coupon_virtually_money > 0 && (!res.data.time_stamps || res.data.time_stamps == 0)) { //有点券无次券
                    this.paymentMethod = "dian";
                } else if (res.data.coupon_virtually_money > 0 && (res.data.time_stamps && res.data.time_stamps > 0)) { //有点券有次券
                    this.paymentMethod = null;
                    this.twoPayTypes = true;
                }
            }).catch((r) => {
                console.log(r);
            })

        },

        payFn: function () { // 支付
            if (!this.paymentMethod) return this.$dialog.toast({ mes: "请选择支付方式" });
            if (!this.active) return this.$dialog.toast({ mes: "请选择支付方式" });
            if (this.cancel) return;
            if (this.paymentMethod == 'ci' && (!this.ciAmountOfMoney || !this.ciId)) {
                return this.$dialog.toast({ mes: "请选择次券金额" })
            }
            this.$dialog.confirm({
                mes: "确认支付?",
                opts: () => {
                    // 传参--
                    console.log(this.cartInfo.id, this.active, this.from, "this.cartInfo");

                    //点券支付
                    if (this.paymentMethod == "dian") {
                        payMovieOrderHandle(this.orderInfo.order_id, this.active, this.from, this.orderInfo.order_no)
                            .then(() => {
                                // this.$router.replace({
                                //     path: '/UncleCodeDetail/' + this.orderInfo.order_id
                                // });
                                location.href = `https://coupon-dev.dangaoss.cn/order-detail/coupon?order_id=${this.orderInfo.page_id}`
                            }).catch(err => {
                                console.log(err, "err-PMO");
                                this.$router.replace({
                                    path: "/user"
                                });
                            })
                    }
                    //次券支付
                    if (this.paymentMethod == "ci") {
                        let _active = 'stamps_yue';
                        if (this.ciAmountOfMoney < this.cartInfo.total_amount) {
                            _active = 'stamps_zh';
                        }
                        payMovieOrderHandle(this.orderInfo.order_id, _active, this.from, this.orderInfo.order_no, this.ciId)
                            .then(() => {
                                // this.$router.replace({
                                //     path: '/UncleCodeDetail/' + this.orderInfo.order_id
                                // });
                                  location.href = `https://coupon-dev.dangaoss.cn/order-detail/coupon?order_id=${this.orderInfo.page_id}`
                            }).catch(err => {
                                console.log(err, "err-PMO");
                                this.$router.replace({
                                    path: "/user"
                                });
                            })
                    }

                }
            });
        },

        payItem: function (index) {
            this.active = index;
        }
    }
}
</script>

<style scoped>
.zfbutton {
    padding: .12rem .5rem;
    border: 0.02rem solid #ccc;
    border-radius: .4rem;
}

.onZfbutton {
    border-color: #fc5445;
    color: #e93323;
}

.payment-title {
    width: 100%;
    height: .88rem;
    text-align: center;
    line-height: .88rem;
    color: white;
    font-size: .32rem;
}



.zuowei {
    margin-right: .2rem;
}

/*  */
.wrapper {
    background-color: #fff;
    margin-top: 0.13rem;
}

.item {
    padding: 0.27rem 0.3rem;
    font-size: 0.3rem;
    color: #282828;
    border-bottom: 1px solid #f0f0f0;
}

.list {
    margin-top: 0.35rem;
}

.payItem {
    border: 1px solid #eee;
    border-radius: 0.06rem;
    height: 0.86rem;
    width: 100%;
    margin-top: 0.2rem;
    font-size: 0.28rem;
    color: #282828;
}

.on {
    border-color: #fc5445;
    color: #e93323;
}

.name {
    width: 30%;
    text-align: center;
    border-right: 1px solid #eee;
}

.iconfont {
    width: 0.44rem;
    height: 0.44rem;
    border-radius: 50%;
    text-align: center;
    line-height: 0.44rem;
    background-color: #fe960f;
    color: #fff;
    font-size: 0.3rem;
    margin-right: 0.15rem;
}

.tip {
    width: 70%;
    text-align: center;
    font-size: 0.26rem;
    color: #aaa;
}

.count-down {
    display: inline-block;
    width: 2.5rem;
    height: .4rem;
    background: #ff5068;
    border-radius: .3rem;
    text-align: center;
    line-height: .4rem;
    color: #fff;
    margin-left: .2rem;
}

.refundlist {
    width: 100%;
    background: white;
    padding-top: 0.1rem;
    display: flex;
    border-bottom: 0.008rem solid #f5f1f1;
}

.userText {
    padding: 0.1rem 0.4rem;
    display: flex;
}

.userDefault {
    width: .45rem;
    height: .3rem;
    background: red;
    font-size: 0.2rem;
    text-align: center;
    line-height: 0.3rem;
    margin-top: 0.05rem;
    margin-right: 0.2rem;
    color: white;
}

.userAddress {
    padding: 0rem 0rem 0.1rem 1.6rem;
}

.routerArrow {
    width: 10%;
    padding-top: .35rem;
}

.detalis_box {
    width: 100%;
    background: white;
    margin-top: 0.2rem;
}

.quantity {
    padding: 0.25rem;
    font-size: 0.28rem;
    font-family: PingFang SC-Heavy, PingFang SC;
    color: #242424;
}

.quantit {
    display: flex;
    background: #fff5f3;
    padding: 0.1rem 0.1rem;
}

.quantit img {
    width: 2rem;
    height: 2rem;
}

.quantiy {
    width: 100%;
    margin-left: 0.2rem;
    display: flex;
    text-align: left;
    justify-content: space-between;
}

.quantiy .size {
    font-family: PingFang SC-Semibold, PingFang SC;
    color: #242424;
    width: 100%;
    font-size: 0.25rem;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-box-pack: center;
    -webkit-box-align: center;
    -webkit-line-clamp: 2;
    overflow: hidden;

}

.quan {
    padding-top: 0.5rem;
    text-align: right;
}

.tity {
    color: #ee453e !important;
    display: flex !important;
    width: 21% !important;
}

.orderer {
    padding: 0.18rem 0.4rem;
    width: 100%;
    background: white;
    border-bottom: 0.008rem solid #f5f1f1;
}

.count-down {
    display: inline-block;
    width: 2.5rem;
    height: .4rem;
    background: #ff5068;
    border-radius: .3rem;
    text-align: center;
    line-height: .4rem;
    color: #fff;
    margin-left: .2rem;
}
</style>